const CSRF_COOKIE_NAME = 'zt_csrf_webapp';

let pendingCsrfToken = null;

export const readCsrfCookie = () => {
    const match = document.cookie.match(new RegExp(`(?:^|; )${CSRF_COOKIE_NAME}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : null;
}

// Covers the race where the CSRF cookie hasn't been flushed to document.cookie
// yet by the time the very next mutating request fires after login/refresh/register.
export const setPendingCsrfToken = token => {
    pendingCsrfToken = typeof token === 'string' && token ? token : null;
}

const consumePendingCsrfToken = () => {
    const token = pendingCsrfToken;
    pendingCsrfToken = null;
    return token;
}

export const getCsrfToken = () => consumePendingCsrfToken() || readCsrfCookie();
